import { render, staticRenderFns } from "./Detail-Vendor.vue?vue&type=template&id=827531ea"
import script from "./Detail-Vendor.vue?vue&type=script&lang=js"
export * from "./Detail-Vendor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports